module.exports = __webpack_public_path__ + "static/tsesteel-logo-2f446a271357f3b9d0887abe1b31d7ea.jpeg";